<template>
	<div class="tab-pane active" id="custom" role="tabpanel">
        <div class="row no-gutters justify-content-center p-2 p-md-5 custom">
            <div class="col-lg-6 col-12 text-center">
                <h2 class="mb-4">A custom vitamin just for you, that changes with you</h2>
                <p class="mb-4">Get the precise supplementation you need at the right time to get ahead in your health.</p>
                <ul class="mb-0 justify-content-center align-items-center d-flex mi-100">
                    <li><router-link to="/custom-suppliment-questionaries" class="btn btn-blue mr-3 discover">Discover your first formula</router-link></li>
                    <li><a href="#" class="btn btn-gray-dark ml-3 discover">Buy supplements ›</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Nutrition",
        data() {
            return {

            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/website/nutrition/pages/custom-suppliment.vue